import HTTP_METHODS from "src/general/constants/http/httpMethods";
import { createBaseQueryDefinition } from "src/business.InterfaceLayer/store/services/utils.service/ResponseTransforms";
import MAIN_PATHS from "src/business.InterfaceLayer/store/mainPaths";
import { ApiQueryBuilder } from "src/business.InterfaceLayer/store/types/ApiQueryBuilder.type";
import AUTH_PATHS from "src/business.InterfaceLayer/store/entities/auth.entity/redux/paths";
import { Nullable } from "../../../../../types/Nullable.type";

const getRequestBaseDefinition = createBaseQueryDefinition(
	HTTP_METHODS.GET,
	MAIN_PATHS.AUTHORIZATION
);

const pingApiGetQueries = (build: ApiQueryBuilder) => ({
	getPing: build.query<Nullable<{}>, {}>({
		query: (params) => ({
			...getRequestBaseDefinition({ path: AUTH_PATHS.PING, params }),
		}),
	}),
});

export default pingApiGetQueries;
